/**
 * @generated SignedSource<<d19902cd61f349a6b13fa84362320a21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "wChannelIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "wMemberId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "wChannelIds",
        "variableName": "wChannelIds"
      },
      {
        "kind": "Variable",
        "name": "wMemberId",
        "variableName": "wMemberId"
      }
    ],
    "concreteType": "ThreadModeSubscription",
    "kind": "LinkedField",
    "name": "threadMode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Member",
        "kind": "LinkedField",
        "name": "member",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "liveChat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activeThreadMode",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationHistoryQueryThreadModeSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConversationHistoryQueryThreadModeSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "56bd632d60738cf302e2f1507f2f950f",
    "id": null,
    "metadata": {},
    "name": "ConversationHistoryQueryThreadModeSubscription",
    "operationKind": "subscription",
    "text": "subscription ConversationHistoryQueryThreadModeSubscription(\n  $wChannelIds: [ID]\n  $wMemberId: ID\n) {\n  threadMode(wChannelIds: $wChannelIds, wMemberId: $wMemberId) {\n    member {\n      id\n      liveChat\n      activeThreadMode\n    }\n  }\n}\n"
  }
};
})();

node.hash = "802e52f272c1b0fe5c4aa383116c6b10";

module.exports = node;
